<template>
    <modal-dialog
        id="phase-builder-dialog"
        :show.sync="shown"
        class="uk-modal-dialog-large"
    >
        <template v-slot:title>
            <h2>Add Phases</h2>
        </template>

        <phase-builder
            id="phase-builder-dialog-picker"
            :value="phase_builder_data"
            @change="update_phase_builder_data"
        />

        <div class="uk-modal-footer">
            <div class="uk-grid uk-grid-small">
                <div class="uk-width-1-2">
                    <p class="uk-text-small uk-text-muted">
                        For each phase that you want to create, fill out at least one of "start date", "end date" or "fee".
                        <br>Leave a phase's row completely empty if it doesn't apply.
                        <br>NOTE: you will be able to manually override any of the phases generated by the phase builder.
                    </p>
                </div>
                <div class="uk-width-1-2 uk-text-right">
                    <base-button
                            size="large"
                            @click.prevent="close"
                        >
                            Cancel
                        </base-button>
                        <base-button
                            color="primary"
                            size="large"
                            :disabled="!has_phase_builder_selection"
                            @click.prevent="apply_phase_builder"
                        >
                            Add Phase(s)
                        </base-button>
                </div>
            </div>
         </div>
    </modal-dialog>
</template>

<script type="text/javascript">
import handles_phase_builder_selection from "../mixins/HandlesPhaseBuilderSelection"

import ModalDialog from "./ModalDialog/ModalDialog"
import PhaseBuilder from "../ui/PhaseBuilder"
import BaseButton from "../ui/BaseButton"

export default {
    mixins: [handles_phase_builder_selection],
    components: {
        ModalDialog,
        PhaseBuilder,
        BaseButton
    },
    watch: {
        show: "reset"
    },
    methods: {
        reset () {
            if(this.show) this.reset_phase_builder()
        },
        close () {
            this.$emit("update:show", false)
        }
    },
    computed: {
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        },
        scope_id () {
            return this.scopeId
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        record: {
            type: Object,
            default () {
                return {}
            }
        },
        scopeId: {
            validator: prop => !prop || (typeof prop === "number"),
            default: null
        }
    }
}
</script>
